<template lang="pug">
v-layout
  v-dialog(v-model="loader" persistent width="300")
    v-card(color="#0855c4")
      v-card-text(style="color: #fff;")
        | {{ textLoader }}
        v-progress-linear(indeterminate color="white" class="mb-0 progress-animation")
</template>
<script>
export default{
  props: ['loader', 'textLoader'],
  methods: {}
}
</script>

<style>
.progress-animation .v-progress-linear__buffer, .progress-animation .v-progress-linear__background, .progress-animation .v-progress-linear__fill {
  animation: progress-animation 2s infinite;
}

@keyframes progress-animation {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

</style>



// WEBPACK FOOTER //
// src/components/Loader.vue